module.exports = {"510705101":"桑枣镇","510705102":"花荄镇","510705103":"黄土镇","510705104":"塔水镇","510705105":"秀水镇","510705106":"河清镇","510705108":"界牌镇","510705109":"永河镇","510705110":"雎水镇","510705111":"清泉镇","510705112":"宝林镇","510705113":"沸水镇","510705114":"晓坝镇","510705115":"乐兴镇","510705116":"千佛镇","510705201":"兴仁乡","510705202":"高川乡","510705203":"迎新乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510705.json
// module id = 2121
// module chunks = 0